import React, { Component } from 'react'

import Api from '../../Services/Api'
import NotificationSystem from 'react-notification-system'

import auth from './Auth'

import Input from 'react-validation/build/input';
import Form from 'react-validation/build/form';
import FormValidator from '../../Validators/form_validator';

export default class SignupForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            passwordConfirmation: '',
            message: '',
        };

        this.handleSignup = this.handleSignup.bind(this)
        this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this)
    }

    postForm() {
        this.request = Api.get('signup', {
            method: "POST",
            body: JSON.stringify({
                email: this.state.email,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                password: this.state.password,
                passwordConfirmation: this.state.passwordConfirmation
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }, false, false).then((response) => {
            this.refs.notificationSystem.addNotification({
                message: response.message,
                level: 'success',
                position: 'tc'
            });
            setTimeout(() => {
                this.props.history.push('/login');
            }, 2500);
        }).catch((err) => {
            console.log(err);
            // response.json().then(body => console.log(body));
            this.refs.notificationSystem.addNotification({
                message: "Could not sign up at this time.",
                level: 'error',
                position: 'tc'
            });
        });
    }

    redirectToRoot(){
        // this.context.router.push('/');
        this.props.history.push("/")
    }

    handleSignup(){
        this.form.validateAll();
        this.postForm();
    }

    handleSubmitOnEnter(event){
        if(event.keyCode === 13){
            this.handleSignup();
         }
    }

    render() {
      return (
        <Form ref={c => { this.form = c }}>
          <NotificationSystem ref="notificationSystem" />
          <div className="authentication-form">

            <h1 className="logo">Huvercraft</h1>
            <div className="form-content">
              <h4>Signup</h4>
                <Input id="firstName" name="firstName" placeholder="First Name" className="first-child"
                    value={this.state.firstName}
                    onChange={ e => this.setState({firstName: e.target.value})}
                    onKeyDown={this.handleSubmitOnEnter}
                    validations={[FormValidator.required]}
                    autoFocus />

                <Input id="lastName" name="lastName" placeholder="Last Name"
                    value={this.state.lastName}
                    onChange={ e => this.setState({lastName: e.target.value})}
                    onKeyDown={this.handleSubmitOnEnter}
                    validations={[FormValidator.required]}
                    autoFocus />

                <Input id="email" name="email" placeholder="Email"
                    type="email"
                    value={this.state.email}
                    onChange={ e => this.setState({email: e.target.value})}
                    onKeyDown={this.handleSubmitOnEnter}
                    validations={[FormValidator.required, FormValidator.email]}
                    autoFocus />

                <Input  id="password" type="password" name="password" placeholder="Password"
                    value={this.state.password}
                    onChange={ e => this.setState({password: e.target.value})}
                    onKeyDown={this.handleSubmitOnEnter}
                    validations={[FormValidator.required, FormValidator.password]}/>

                <Input  id="confirm" type="password" name="confirm" placeholder="Confirm Password" className="last-child"
                    value={this.state.passwordConfirmation}
                    onChange={ e => this.setState({passwordConfirmation: e.target.value})}
                    onKeyDown={this.handleSubmitOnEnter}
                    validations={[FormValidator.required]}/>

                <button type="button" onClick={this.handleSignup} className="btn btn-medium btn-primary">Signup</button>



            </div>
            <div className="additional-auth-links">
                <a href="mailto:support@huvercraft.com">Account Support</a>
                <a href="/login">Already have an account? Login</a>
              </div>

          </div>
        </Form>
      );
    }

}



// WEBPACK FOOTER //
// ./src/Containers/Authentication/SignupForm.js